import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import "./IdentificationTable.css"; // Import CSS

const IdentificationTable = () => {
  const [identifications, setIdentifications] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(5);

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/api/identifications`, {
          params: { user },
        })
        .then((response) => {
          setIdentifications(response.data);
        })
        .catch((error) => {
          console.error(
            "There was an error fetching the identifications!",
            error
          );
        });
    } else {
      console.error("No user found in localStorage");
    }
  }, []);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const offset = currentPage * itemsPerPage;
  const currentPageData = identifications.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(identifications.length / itemsPerPage);

  return (
    <div className="table-container">
      <table className="identification-table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Species</th>
            <th>Time</th>
            <th>Approved</th>
          </tr>
        </thead>
        <tbody>
          {currentPageData.map((identification) => (
            <tr key={identification.id}>
              <td>
                <img
                  src={`${process.env.REACT_APP_API_URL}/static/identified_pics/${identification.id}.jpg`}
                  alt={`Identification ${identification.id}`}
                  className="identification-image"
                />
              </td>
              <td>{identification.species}</td>
              <td>{identification.time}</td>
              <td>{identification.approved ? "Yes" : "No"}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <ReactPaginate
        previousLabel={"← Previous"}
        nextLabel={"Next →"}
        breakLabel={"..."}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        containerClassName={"pagination"}
        activeClassName={"active"}
        previousLinkClassName={"pagination__link"}
        nextLinkClassName={"pagination__link"}
        disabledClassName={"pagination__link--disabled"}
        breakClassName={"pagination__break"}
        breakLinkClassName={"pagination__break-link"}
        pageClassName={"pagination__page"}
        pageLinkClassName={"pagination__page-link"}
      />
    </div>
  );
};

export default IdentificationTable;
